import { applyPromotion } from "./submitCoupon";

export const PROMOTION_NAME = "cart-summary-promotion";
export const PROMOTION_RADIO_SELECTOR = `input[name=${PROMOTION_NAME}]`;
export const PROMOTION_RADIO_CHECKED_SELECTOR =
    PROMOTION_RADIO_SELECTOR + ":checked";

export const TOTAL_COST_FOR_AD_PRICE = ".total-cost-for-ad__price--js";

export const ORDER_SUMMARY_FINAL_TOTAL_PRICE_CLASS =
    ".final-total-cost__price--js";
export const ORDER_SUMMARY_DISCOUNT_LABEL_CLASS =
    ".order-summary-discount__label";
export const ORDER_SUMMARY_DISCOUNT_MESSAGE_CLASS =
    ".order-summary-discount__message";
export const ORDER_SUMMARY_DISCOUNT_PRICE_CLASS =
    ".order-summary-discount__price";
export const ORDER_SUMMARY_DISCOUNT_DISCOUNT_JS = ".order-summary-discount--js";
export const CART_SUMMARY_NEXT_BILLING_DATE_JS =
    ".cart-summary__next-billing-date--js";

export const CART_SUMMARY_COUPON_FIELD_CLASS =
    ".cart_summary_apply_coupon__coupon_field";
export const BASE_PRICE_ATTR = "normal-price";
export const APPLY_COUPON_JS = ".apply-coupon-js";
export const TEXT_ERROR = ".text-error";

export const CHECKOUT_BUTTON_JS = ".checkout-button-js";

export const IS_COUPON_AUTO_APPLIED = "input[name=is_coupon_auto_applied]";
export const APPLIED_COUPON_FIELD_NAME = "applied_coupon";
export const APPLIED_COUPON_FIELD_INPUT =
    "input[name=" + APPLIED_COUPON_FIELD_NAME + "]";

export const format_currency = (amount, numberOfDecimals = 2) => {
    return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: numberOfDecimals,
    }).format(amount);
};

/**
 * @returns {boolean}
 */
export const userHasPromotionSelected = () => {
    return $(PROMOTION_RADIO_CHECKED_SELECTOR).val() == 1;
};

export const showLoadingSpinner = () => {
    jQuery(APPLY_COUPON_JS).attr(
        "src",
        "/homespotter/darwin/images/spin-1s-30px.svg"
    );
};

export const getAppliedPromotionCouponCode = () => {
    return jQuery(APPLIED_COUPON_FIELD_INPUT).val();
};

export const resetCouponFields = () => {
    if (jQuery(IS_COUPON_AUTO_APPLIED).val() === "0") {
        jQuery(APPLIED_COUPON_FIELD_INPUT).val("");
        jQuery(CART_SUMMARY_COUPON_FIELD_CLASS).val("");
        jQuery(APPLY_COUPON_JS).attr(
            "src",
            "/homespotter/darwin/images/right-arrow.svg"
        );
        jQuery(TEXT_ERROR).hide();
    } else {
        applyPromotion(getAppliedPromotionCouponCode());
    }
};

export const removeDiscountLabel = () => {
    jQuery(ORDER_SUMMARY_DISCOUNT_PRICE_CLASS).text("");
    jQuery(ORDER_SUMMARY_DISCOUNT_LABEL_CLASS).text("");
    jQuery(ORDER_SUMMARY_DISCOUNT_MESSAGE_CLASS).text("");
};

export const resetToBasePrice = () => {
    let rawPrice =
        jQuery(ORDER_SUMMARY_FINAL_TOTAL_PRICE_CLASS).data(BASE_PRICE_ATTR) /
        100;
    let formattedPrice = format_currency(rawPrice);

    jQuery(ORDER_SUMMARY_FINAL_TOTAL_PRICE_CLASS).text(formattedPrice);
};

export const getAvailablePromotionCode = () => {
    return jQuery("input[name=cart-summary-promotion]:checked").data(
        "coupon-code"
    );
};

export const disableCouponField = () => {
    jQuery(CART_SUMMARY_COUPON_FIELD_CLASS).val("");
    jQuery(CART_SUMMARY_COUPON_FIELD_CLASS).prop("disabled", true);

    jQuery(APPLY_COUPON_JS).attr(
        "src",
        "/homespotter/darwin/images/right-arrow.svg"
    );
    jQuery(APPLY_COUPON_JS).prop("disabled", true);
};

export const disableCheckoutButton = () => {
    jQuery(CHECKOUT_BUTTON_JS).prop("disabled", true);
};

export const enableCheckoutButton = () => {
    jQuery(CHECKOUT_BUTTON_JS).prop("disabled", false);
};

export const handleCheckoutButton = (() => {
    // set up closure scope
    var state = [];

    // return function with access to the closure scope
    return function (enabled, src) {
        let objIndex = state.findIndex((obj) => obj.source == src);

        if (objIndex == -1) {
            state = [{ source: src, enabled: enabled }, ...state];
        } else {
            state[objIndex] = { source: src, enabled: enabled };
        }

        var any_disables = state.filter((src) => !src.enabled);

        any_disables.length > 0
            ? disableCheckoutButton()
            : enableCheckoutButton();

        return state;
    };
})();

export const enableCouponField = () => {
    jQuery(".coupon_container--js").show();

    jQuery(CART_SUMMARY_COUPON_FIELD_CLASS).prop("disabled", false);
    jQuery(APPLY_COUPON_JS).prop("disabled", false);
};
